import type { ProgressStepId } from 'api/onboarding/progress';

import { LOCATION_PATH, ONBOARDING_PATH } from 'constants/path';

import type en from './__translations__/en.json';

export type OnboardingStep = {
  analyticsEventName: string;
  analyticsStepName: string;
  id: string;
  labelKey: keyof (typeof en)['Steps'];
  progressStepId: ProgressStepId;
};

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    analyticsEventName: 'view_onboarding_point_of_sale',
    analyticsStepName: 'point_of_sale',
    id: 'point-of-sale',
    labelKey: 'pointOfSale',
    progressStepId: 'point_of_sale',
  },
  {
    analyticsEventName: 'view_onboarding_menu_builder',
    analyticsStepName: 'menu_builder',
    id: 'menu-builder',
    labelKey: 'menuBuilder',
    progressStepId: 'menu_builder',
  },
  {
    analyticsEventName: 'view_onboarding_sales_tax',
    analyticsStepName: 'sales_tax',
    id: 'sales-tax',
    labelKey: 'salesTax',
    progressStepId: 'sales_tax',
  },
  {
    analyticsEventName: 'view_onboarding_orders',
    analyticsStepName: 'order_intake',
    id: 'order-intake',
    labelKey: 'orderIntake',
    progressStepId: 'order_intake',
  },
  {
    analyticsEventName: 'view_onboarding_delivery',
    analyticsStepName: 'delivery',
    id: 'delivery',
    labelKey: 'delivery',
    progressStepId: 'delivery',
  },
  {
    analyticsEventName: 'view_onboarding_payment_setup',
    analyticsStepName: 'payment_setup',
    id: 'payment-setup',
    labelKey: 'paymentSetup',
    progressStepId: 'payment_setup',
  },
  {
    analyticsEventName: 'view_onboarding_website_setup',
    analyticsStepName: 'website_setup',
    id: 'website-setup',
    labelKey: 'websiteSetup',
    progressStepId: 'website_setup',
  },
  {
    analyticsEventName: 'view_onboarding_brand_assets',
    analyticsStepName: 'brand_assets',
    id: 'brand-assets',
    labelKey: 'brandAssets',
    progressStepId: 'brand_assets',
  },
];

export function onboardingPath(restaurantId: string, stepId?: string) {
  const landingPath = `${LOCATION_PATH}/${restaurantId}${ONBOARDING_PATH}`;

  return stepId ? `${landingPath}/${stepId}` : landingPath;
}
